import { Box } from "@mui/material";
import { endOfDay, parseISO } from "date-fns";
import CardThumbnail from "@/components/common/thumbnail/cardThumbnail";
import { SALMON, YELLOW } from "@/config/mui/colorPalette";
import { getTimeDifferenceString } from "@/utils/date";

type PackageCardHeaderProps = {
  thumbnailUrl: string;
  packageSavings: number;
  isFeaturedDeal?: boolean;
  endDate?: string;
  isMobile: boolean;
};

export default function PackageCardHeader({
  thumbnailUrl,
  packageSavings,
  isFeaturedDeal,
  endDate,
  isMobile,
}: PackageCardHeaderProps) {
  const thumbnailChips = [
    packageSavings > 0 && {
      label: `$${packageSavings.toFixed(0)} Savings`,
      textColor: SALMON[100],
      backgroundColor: SALMON[40],
    },
    isFeaturedDeal &&
      endDate && {
        label: `Ends in ${getTimeDifferenceString(endOfDay(parseISO(endDate)), new Date())}`,
        textColor: YELLOW[100],
        backgroundColor: YELLOW[40],
      },
  ].filter(Boolean);

  return (
    <Box sx={{ position: "relative" }}>
      <CardThumbnail
        url={thumbnailUrl}
        height={isMobile ? 110 : 150}
        chips={thumbnailChips}
        isMobile={isMobile}
      />
    </Box>
  );
}
